// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemDescriptionColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tooltip, Typography } from 'antd';
import translateX from 'utils/translateX';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the product description column for item subtables.
// options.size: 'small' (11px, default) | 'middle' (14px)
function itemDescriptionColumn(options = {}) {
  const { size } = options;
  const fontSize = resolveItemFontSize(size, 11);

  return {
    title: translateX('description'),
    dataIndex: ['product', 'name'],
    ellipsis: true,
    defaultSortOrder: 'ascend',
    sorter: (a, b) => {
      const aVal = a?.product?.name || a?.description || '';
      const bVal = b?.product?.name || b?.description || '';
      return aVal.localeCompare(bVal);
    },
    render: (_, item) => (
      <Tooltip title={item?.product?.name || item?.description}>
        <Text style={{ fontSize }}>{item?.product?.name || item?.description || '—'}</Text>
      </Tooltip>
    ),
  };
}

export default itemDescriptionColumn;
